import { useFormikBugFixContext } from "../contexts/FormikWrapper";
import { isRequiredField } from "../functions/isRequiredFormField";

export const useGetInputRequiredValue = (required: boolean | undefined, name: string) => {
	const { validationSchema } = useFormikBugFixContext();

	return Boolean(required || (validationSchema && isRequiredField(validationSchema, name)));
};